// extracted by mini-css-extract-plugin
module.exports = {"MerchantNameContainer":"MerchantName_MerchantNameContainer__WInEZ","FullName":"MerchantName_FullName__QyHTS"};